import { motion, useDragControls } from "framer-motion";
import { X, Minus } from "lucide-react";

export default function WindowFrame({
    winKey,
    title,
    icon: Icon,
    focused,
    zIndex,
    initial,
    onClose,
    onMinimize,
    onFocus,
    sizeClass = "w-[min(94vw,780px)] h-[min(76vh,580px)]",
    contentClass = "bg-[#f6f5f4] text-[#1a1a1a]",
    children,
}) {
    const controls = useDragControls();

    return (
        <motion.div
            data-testid={`window-${winKey.replace(":", "-")}`}
            drag
            dragControls={controls}
            dragListener={false}
            dragMomentum={false}
            dragConstraints={{ left: -400, right: 1400, top: -40, bottom: 700 }}
            initial={{ opacity: 0, scale: 0.92, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 16 }}
            transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
            onPointerDown={onFocus}
            style={{ zIndex, left: initial.x, top: initial.y }}
            className={`absolute flex flex-col rounded-lg overflow-hidden border ${
                focused
                    ? "border-white/25 shadow-[0_36px_90px_rgba(0,0,0,0.65)]"
                    : "border-white/10 shadow-[0_18px_50px_rgba(0,0,0,0.4)]"
            } ${sizeClass}`}
        >
            <div
                onPointerDown={(e) => controls.start(e)}
                className={`flex items-center justify-between h-10 px-3 shrink-0 cursor-grab active:cursor-grabbing select-none transition-colors ${
                    focused ? "bg-[#2b2e34]" : "bg-[#24262b]"
                }`}
            >
                <div className="flex items-center gap-2 min-w-0 text-xs font-medium text-neutral-300">
                    {Icon && <Icon size={13} className="text-neutral-400 shrink-0" />}
                    <span className="truncate">{title}</span>
                </div>
                <div className="flex items-center gap-1.5 shrink-0">
                    <button
                        data-testid={`win-min-${winKey.replace(":", "-")}`}
                        onClick={onMinimize}
                        onPointerDown={(e) => e.stopPropagation()}
                        aria-label="Minimize window"
                        className="w-6 h-6 rounded flex items-center justify-center text-neutral-400 hover:bg-white/10 hover:text-white transition-colors"
                    >
                        <Minus size={13} />
                    </button>
                    <button
                        data-testid={`win-close-${winKey.replace(":", "-")}`}
                        onClick={onClose}
                        onPointerDown={(e) => e.stopPropagation()}
                        aria-label="Close window"
                        className="w-6 h-6 rounded flex items-center justify-center text-neutral-400 hover:bg-vermilion hover:text-white transition-colors"
                    >
                        <X size={13} />
                    </button>
                </div>
            </div>
            <div className={`flex-1 overflow-y-auto ${contentClass}`}>{children}</div>
        </motion.div>
    );
}
